// extracted by mini-css-extract-plugin
export default {"header":"Table_header__dMQqx","link":"Table_link__6i3o1","active":"Table_active__b8iG+","inactive":"Table_inactive__e3lez"};